import { Change, Changes, Sub } from './types';

export const changes: Changes = {
  subs: new Array<{ (change: Change): void }>(),
  subscribe: (fn: { (change: Change): void }) => {
    changes.subs.push(fn);
  },
  unsubscribe: (fn: { (change: Change): void }) => {
    changes.subs = changes.subs.filter((sub) => sub !== fn);
  },
  applyChange: (change: Change) => {
    changes.subs.forEach((sub) => {
      try {
        sub(change);
      } catch (e) {
        console.error(e);
      }
    });
  },
};

const subs = new Map<string, Sub[]>();
const globs = [] as Sub[];

export function subscribe(fn: Function, event?: string, scope?: any) {
  if (!event) return globs.push({ fn, scope });
  if (!subs.has(event)) {
    subs.set(event, []);
  }
  return subs.get(event)!.push({ fn, scope });
}

export function unsubscribe(delFn: Function, event: string) {
  if (!subs.has(event)) return;
  subs.set(
    event,
    subs.get(event)!.filter(({ fn }) => fn !== delFn)
  );
}

export function emit(event: string, ...attrs: any[]) {
  globs.forEach(({ fn, scope }) => fn.apply(scope, [event, ...attrs]));
  if (!subs.has(event)) return;
  subs.get(event)!.map(({ fn, scope }) => fn.apply(scope, attrs));
}
